var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheque = function SvgCheque(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0875C4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.167 7.167H16.5V8h-3.333zM4.834 7.167h4.167V8H4.834zM4.834 8.834h2.5v.833h-2.5zM4.834 13h3.333v.833H4.834zM9 13h3.333v.833H9zM13.167 13H16.5v.833h-3.333zM4.834 11.334h5.833v.833H4.834zM12.334 10.5h4.167v1.667h-4.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 4.667h18.333v11.666H1.5zm1.667 1.666v8.334h15V6.333z",
    clipRule: "evenodd"
  }))));
};
export { SvgCheque as Icon };
export default __webpack_public_path__ + "static/media/c2048b973f1b2e2ed57b0c87fe906933.svg";